import React from 'react';

import { Route, Routes } from 'react-router-dom';

import RedirectHelper from 'routes/CounselorRoutes/RedirectHelper';

const CounselorRedirects = () => (
  <Routes>
    <Route path="/dashboard" element={<RedirectHelper isDashboardRedirect />} />
    <Route
      path="/el/dashboard"
      element={<RedirectHelper isDashboardRedirect />}
    />
    <Route path="/login/k12" element={<RedirectHelper isDashboardRedirect />} />
  </Routes>
);

export default CounselorRedirects;
